import { useEffect, useState } from 'react';

/**
 * https://usehooks.com/useWindowSize/
 * @param breakpoint - a configurable value to determine mobile status
 * returns {height, width}
 */
export const useWindowSize = (breakpoint = 900) => {
  const getSize = () => ({
    height: window.innerHeight,
    isMobile: window.innerWidth < breakpoint,
    width: window.innerWidth,
  });

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};
